import { mapGetters } from 'vuex'

export default {
  computed: mapGetters({
    propertyDetails: 'Properties/propertyDetails',
    currentSelectedOrg: 'Permissions/currentSelectedOrg',
    canViewProperty: 'Permissions/canViewProperty',
  }),
  watch: {
    currentSelectedOrg: {
      handler: function (newOrg) {
        const canViewPropertyOnNewOrg = newOrg.id && this.propertyDetails.organization.id === newOrg.id
        if (!canViewPropertyOnNewOrg) this.$router.push('/properties')
      },
      deep: true,
    },
  },
}
